module.exports = __webpack_public_path__ + "img/hall-of-fame_8.6e93cc2f.jpg";